import { render, staticRenderFns } from "./EditablePaginator.vue?vue&type=template&id=9dd80b06&"
import script from "./EditablePaginator.vue?vue&type=script&lang=js&"
export * from "./EditablePaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports